import { useLayoutEffect, useEffect } from "react";
import { useAuth } from "@/features/auth";
import { isFreePlan, useEntitlements } from "@/features/subscriptions";
import { POSTHOG_ENABLED } from "@/config/posthog";
import {
	identifyUser,
	registerSuperProps,
	resetAnalytics,
	setPersonProps,
} from "@/utils/analytics";

/**
 * Tags every later event (super properties) and the person with the current
 * plan, so any insight can be split by free vs paid without per-event props.
 * Mounted only for signed-in users, since it needs the subscription queries.
 */
function PlanProperties() {
	const { plan } = useEntitlements();
	const planName = plan?.nombre;
	const isFree = plan ? isFreePlan(plan) : undefined;

	useEffect(() => {
		if (!planName) return;
		const props = { plan_name: planName, is_free_plan: isFree };
		registerSuperProps(props);
		setPersonProps(props);
	}, [planName, isFree]);

	return null;
}

export function PostHogUserIdentify() {
	const { user } = useAuth();

	// Layout effects run before every passive effect of the same commit, so the
	// user is identified before PlanProperties attaches the plan to them.
	useLayoutEffect(() => {
		if (user) {
			identifyUser(user.id, {
				email: user.email,
				username:
					user.user_metadata?.full_name ||
					user.user_metadata?.name ||
					undefined,
				signup_date: user.created_at,
			});
		} else {
			resetAnalytics();
		}
	}, [user]);

	// Without PostHog (local dev) there is nothing to tag, and the subscription
	// queries behind the plan are not worth firing.
	return user && POSTHOG_ENABLED ? <PlanProperties /> : null;
}
